import { render } from "./MetierPage.vue?vue&type=template&id=c8229aa4&scoped=true"
import script from "./MetierPage.vue?vue&type=script&lang=js"
export * from "./MetierPage.vue?vue&type=script&lang=js"

import "./MetierPage.vue?vue&type=style&index=0&id=c8229aa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8229aa4"]])

export default __exports__